/**
 * Single source of truth for product naming, color palette, and typography.
 * Renaming the product means editing this file. No other code path should
 * hardcode any of these values.
 */
export const branding = {
    productName: 'Switchboard',
    parentBrand: 'Brink Tech',
    productLockup: 'Switchboard, by Brink Tech',
    productShortLockup: 'Switchboard',
    productDomain: 'app.brinktech.io',
    bookingDomain: 'book.brinktech.io',
    apiDomain: 'api.brinktech.io',
};
export const colors = {
    navy: '#0A0E1A',
    teal: '#00C2C7',
    offwhite: '#F4F6F8',
    ink: '#1A1A1A',
    grey: '#5A6470',
    lightGrey: '#E8EAED',
    white: '#FFFFFF',
    identityColors: {
        navy: '#0A0E1A',
        teal: '#00C2C7',
        slate: '#3F4A5C',
        stone: '#8B7E6A',
    },
    states: {
        success: '#2E7D4F',
        warning: '#C77A00',
        danger: '#B33A3A',
    },
};
export const typography = {
    fontStack: `Calibri, 'Segoe UI', Inter, -apple-system, BlinkMacSystemFont, sans-serif`,
};
/**
 * Every hex color used in the product must appear in this set. The lint:colors
 * script verifies the rule by scanning the codebase outside this file.
 */
export const allowedHexColors = new Set([
    colors.navy,
    colors.teal,
    colors.offwhite,
    colors.ink,
    colors.grey,
    colors.lightGrey,
    colors.white,
    ...Object.values(colors.identityColors),
    ...Object.values(colors.states),
].map((hex) => hex.toLowerCase()));
//# sourceMappingURL=branding.js.map